import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';
import Icon from '../../Icon';

import { getColorToState } from 'utils/pos';

const PelletContainer = styled.div`
  width: 7px;
  height: 7px;
  min-width: 7px;
  border-radius: ${(props) => (props.square ? '0px' : '50%')};
  background-color: ${(props) =>
    props.color ? props.color : getColorToState(props.value)};
`;

const ValueContainer = styled.div`
  margin-left: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Cell = ({ value, showRssOrangeIcon, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {value && (
      <PelletContainer
        value={value.evolution}
        square={value.square}
        color={value.color}
      />
    )}
    {value && value.value && <ValueContainer>{value.value}</ValueContainer>}
    {showRssOrangeIcon && (
      <Icon style={{ marginLeft: '5px', color: 'orange' }} icon="rssIcon" />
    )}
  </CellContainer>
);

export default Cell;
